import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { broadcastScheduleQueryKeys } from '@/features/broadcast-schedule/api/query-keys';
import { TProgramBroadcastSegmentsPatch } from '@/features/broadcast-schedule/types';
import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';
import { emptyStringValues } from '@/utils/objects';

import { TSegment } from '../types';

export async function patchSegment(body: TProgramBroadcastSegmentsPatch): Promise<TSegment> {
  return mediaManagerClient
    .patch(`/api/v1/segments/${body.id}`, emptyStringValues(body))
    .then(response => response as unknown as TSegment);
}

type MutationFn = typeof patchSegment;

type TUsePatchSegmentLogoParams = {
  config?: MutationConfig<MutationFn>;
  id?: string;
};

export function usePatchSegment({ config, id }: TUsePatchSegmentLogoParams = {}) {
  const { order_by, gte, lte, review_states, search, tags, people, logos } =
    useProgramBroadcastFilters();

  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchSegment,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El segmento se ha actualizado correctamente'));
      queryClient.invalidateQueries({
        queryKey: [
          broadcastScheduleQueryKeys.broadcastSchedule(),
          id,
          { order_by, review_states, search, gte, lte, tags, people, logos },
        ],
      });
    },
  });
}
